import { downloadBlob } from 'Logic/downloadUrl.js'
import { useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let debug = useDataValue({
    context: 'dwt',
    path: 'debug',
    viewPath: props.viewPath,
  })

  return function onClick() {
    downloadBlob({
      blob: new Blob([debug.join('\n')], { type: 'text/plain' }),
      file_name: `${Date.now()}-twain-debug.txt`,
    })
  }
}
